import { render, staticRenderFns } from "./helpDocument.vue?vue&type=template&id=28923cd8&scoped=true&"
import script from "./helpDocument.vue?vue&type=script&lang=js&"
export * from "./helpDocument.vue?vue&type=script&lang=js&"
import style0 from "./helpDocument.vue?vue&type=style&index=0&id=28923cd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28923cd8",
  null
  
)

export default component.exports